import { render, staticRenderFns } from "./manual-transferV2.vue?vue&type=template&id=5d03f40f"
import script from "./manual-transferV2.vue?vue&type=script&lang=js"
export * from "./manual-transferV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports